export const backdropVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 0.5 },
}
export const panelVariants = {
    hidden: { opacity: 0, y: '-100%' },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.1,
            type: 'spring' as const,
            damping: 25,
            stiffness: 500,
        },
    },
    exit: {
        y: '100%',
        opacity: 0,
        transition: {
            duration: 0.1,
            type: 'spring' as const,
            damping: 25,
            stiffness: 500,
        },
    },
}